
<div class="p-10" fxLayoutAlign="space-between center">
    <div>
        Reception échantillon
    </div>
    <button color="primary" mat-raised-button>Enregistrer</button>
</div>
<div class="p-10" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Num échantillon (compteur)</mat-label>
        <input type="number" matInput placeholder="Num échantillon (compteur)">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Code article</mat-label>
        <input matInput placeholder="Code article">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Num lot</mat-label>
        <input matInput placeholder="Num lot">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Date  de recption</mat-label>
        <input matInput placeholder="Date  de recption">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Date sys</mat-label>
        <input matInput placeholder="Date sys">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Receveur (perso)</mat-label>
        <input matInput placeholder="Receveur (perso)">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Société</mat-label>
        <input matInput placeholder="Société">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Analyse physico</mat-label>
        <input matInput placeholder="Analyse physico">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Analyse micro bio</mat-label>
        <input matInput placeholder="Analyse micro bio">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Analyse autre</mat-label>
        <input matInput placeholder="Analyse autre">
    </mat-form-field>
    <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea matInput placeholder="Description"></textarea>
    </mat-form-field>
</div>